import { NavLink, useNavigate } from "react-router-dom"
import { NEWPROJECTREQUEST, NEWCPPREQUEST, SAVECPPCHILDREQUEST_URL, ValidateProgramProject_URL } from "../../constants"
import { Steps } from "primereact/steps";
import { Card } from "primereact/card";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import img from '../../assets/CreateProject.svg';
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import Spinner from "../../components/shared/spinner.jsx";
import { hasDisallowedNameCharacters, buildDisallowedNameCharsMessage } from "../../utils/nameValidation";
import "../newClientRequest/newClientRequestForm.scss";
import addicon from '../../assets/Add-Icon.svg';
import deleteicon from '../../assets/Trash_Icon.svg';
import { getDropdownValues, getparentandultimateclientAttributes, getChannelDropdownList } from "../../pages/newClientRequest/dropdownService";
import { Tree } from 'primereact/tree';
import { TreeNode } from "primereact/treenode";
import axios from "../../datasource/axios";
import { hideLoader } from "../../datasource/msal";
import helpicon from '../../assets/Help_Icon.svg';
import { Tooltip } from 'primereact/tooltip';

interface Item {
  name: string;
  code: number;
}

interface CustomNode {
  id: string;
  name: string;
  channel?: Item[];
  children?: CustomNode[];
}

interface CustomTreeNode extends TreeNode {
  channel?: Item[];
}

const convertToTreeNode = (node: CustomNode): CustomTreeNode => ({
  key: node.id,
  label: node.name + ' (' + node.id.replace("_", " ") + ')',
  children: node.children?.length ? node.children.map(convertToTreeNode) : [],
  channel: node.channel
});


export const NewProjectRequestForm = (props: any) => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URI as string;
  const [items, setItems] = useState<any>([]);
  const [isVisibleDiv1, setVisibleDiv1] = useState(true);
  const [isVisibleDiv2, setVisibleDiv2] = useState(false);
  const [isVisibleDiv3, setVisibleDiv3] = useState(false);
  const [isVisibleDiv4, setVisibleDiv4] = useState(false);
  const [issubmit, setissubmit] = useState(false);
  const [issave, setissave] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [issubmitsuccess, setissubmitsuccess] = useState(false);
  const [issavesuccess, setissavesuccess] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Item | null>(null);
  const [selectedPrograms, setSelectedPrograms] = useState<Item | null>(null);
  const [clients, setClients] = useState<Item[]>([{ 'name': '', 'code': 0 }]);
  const [programs, setPrograms] = useState<Item[]>([{ 'name': '', 'code': 0 }]);
  const client: Item[] = clients.map((client, i) => ({ name: `${client.name} - ${client.code}`, code: client.code }));
  const [parents, setParents] = useState<CustomNode[]>([]);
  const [data, setData] = useState<CustomNode[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<any>({});
  const [supportgroups, setSupportGroups] = useState([]);
  const managedbyRef = useRef<any>();
  const toast = useRef<any>(null);
  const opsvpRef = useRef<any>();
  const [selectedSupportGrp, setSelectedSupportGrp] = useState({ "code": "", "name": "" });
  const [selectedManagedBy, setSelectedManagedBy] = useState("");
  const [selectedOpsvp, setSelectedOpsvp] = useState("");
  const [isdisabled, setisdisabled] = useState(true);
  const projectRef = useRef<any>();
  let countrecords: number = 0;
  let countprojectvalue: number = 0;
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  const [channelTypes, setChannelTypes] = useState<any[]>([]);

  // Custom channel multiselect state
  const [channelDropdownOpen, setChannelDropdownOpen] = useState<{ [key: string]: boolean }>({});
  const channelDropdownRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const openKeys = Object.keys(channelDropdownOpen).filter(k => channelDropdownOpen[k]);
      openKeys.forEach(key => {
        if (channelDropdownRefs.current[key] && !channelDropdownRefs.current[key]!.contains(e.target as Node)) {
          setChannelDropdownOpen(prev => ({ ...prev, [key]: false }));
        }
      });
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [channelDropdownOpen]);

  const toggleChannelDropdown = (key: string) => {
    setChannelDropdownOpen(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const nodeTemplate = (node: CustomTreeNode) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <i style={{ marginRight: '8px' }}></i>
      <span>{node.label?.split(" ")[0] === '' ? 'Empty ' + node.label : node.label}</span>
      {node.channel && node.channel.length > 0 && (
        <span style={{ marginLeft: '10px', fontSize: '14px', color: '#555' }}>
          [{node.channel.map((c: Item) => c.name).join(", ")}]
        </span>
      )}
    </div>
  );

  const getchanneltypes = async () => {
    let channelresponse: any = await getChannelDropdownList();
    let codes = channelresponse?.channeltypes;
    setChannelTypes(codes);
  }

  const handleAddChild = (parentId: string) => {
    const defaultChannel = channelTypes?.find((c: any) => c.code === "1");
    setParents(parents.map(parent =>
      parent.id === parentId
        ? {
          ...parent,
          children: [
            ...parent?.children!,
            {
              id: parent?.children?.length ? "project_" + (parseInt(parent.children[parent.children.length - 1].id.split("_")[1]) + 1).toString() : "project_1",
              name: '',
              channel: defaultChannel ? [defaultChannel] : []
            }
          ]
        }
        : parent
    ));
  };

  const handleChangeChild = (parentId: string, childId: string, name: string) => {
    setParents(parents.map(parent =>
      parent.id === parentId
        ? {
          ...parent,
          children: parent?.children?.map(child =>
            child.id === childId
              ? { ...child, name }
              : child
          )
        }
        : parent
    ));
  };

  const handleRemoveChild = (parentId: string, childId: string) => {
    setParents(parents.map(parent =>
      parent.id === parentId
        ? { ...parent, children: parent?.children?.filter(child => child.id !== childId) }
        : parent
    ));
  };

  const getdropdowndata = async () => {
    let clientResponse: any = await getparentandultimateclientAttributes("c");
    let codes = clientResponse?.codes;
    setClients(codes);
  }

  const getdropdowndataprogram = async (type: string, code: string) => {
    let clientResponse: any = await getparentandultimateclientAttributes(type, code);
    let codes = clientResponse?.codes;
    setPrograms(codes);
  }

  useEffect(() => {
    setvisibleforms();
    getdropdowndata();
    getsupportgroups();
    getchanneltypes();
  }, []);

  useEffect(() => {
    if (channelTypes && channelTypes.length > 0) {
      const defaultChannel = channelTypes.find((c: any) => c.code === "1");
      if (defaultChannel) {
        setParents(prev => prev.map(p => ({
          ...p,
          children: p.children?.map(c => ({
            ...c,
            channel: (c.channel && c.channel.length > 0) ? c.channel : [defaultChannel]
          }))
        })));
      }
    }
  }, [channelTypes]);

  useEffect(() => {
    if (selectedItem?.name !== undefined) {
      setData([
        {
          id: "client",
          name: selectedItem?.name,
          children: parents
        }
      ]);

      if (isVisibleDiv2 && selectedPrograms !== null) {
        setisdisabled(false);
      }
      else {
        setisdisabled(true);
      }

      if (isVisibleDiv3) {
        let hasInvalidNameInDiv3 = false;
        let hasInvalidNameOnClick = false;
      parents.map(parent => {
          parent?.children?.map(child => {
            if (seen.has(child.name.trim())) {
              duplicates.add(child.name.trim());
            } else {
              seen.add(child.name.trim());
            }
            if (hasDisallowedNameCharacters(child.name)) { hasInvalidNameInDiv3 = true; }
          if (child.name.trim() !== '') { countrecords = countrecords + 1; }
            countprojectvalue = countprojectvalue + 1;
          });
        });

        (countrecords > 0 && countrecords === countprojectvalue && duplicates.size === 0 && !hasInvalidNameInDiv3) ? setisdisabled(false) : setisdisabled(true);
      }
    }
  }, [parents]);

  const setvisibleforms = () => {
    setItems(([{
      label: 'Client',
      command: (event: any) => {
        setVisibleDiv1(true);
        setVisibleDiv2(false);
        setVisibleDiv3(false);
        setVisibleDiv4(false);
        setissave(false);
        setissubmit(false);
      }
    },
    {
      label: 'Program',
      command: (event: any) => {
        setVisibleDiv1(false);
        setVisibleDiv2(true);
        setVisibleDiv3(false);
        setVisibleDiv4(false);
        setissave(false);
        setissubmit(false);
      }
    },
    {
      label: 'Project',
      command: (event: any) => {
        setVisibleDiv1(false);
        setVisibleDiv2(false);
        setVisibleDiv3(true);
        setVisibleDiv4(false);
        setissave(false);
        setissubmit(false);
      }
    },
    {
      label: 'AskNow Business Service',
      command: (event: any) => {
        setVisibleDiv1(false);
        setVisibleDiv2(false);
        setVisibleDiv3(false);
        setVisibleDiv4(true);
        setissave(false);
        setissubmit(false);
      }
    },
    {
      label: 'Review',
      command: (event: any) => {
        setVisibleDiv1(false);
        setVisibleDiv2(false);
        setVisibleDiv3(false);
        setVisibleDiv4(false);
        setissave(false);
        setissubmit(false);
      }
    }])
    );
  }

  let onHideShowClick = (divId: number) => {
    setActiveIndex(divId);
    setissave(false);
    setissubmit(false);
    if (divId == 0) {
      setVisibleDiv1(true);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      if (selectedItem !== null) {
        setisdisabled(false);
      }
    }
    if (divId == 1) {
      setVisibleDiv1(false);
      setVisibleDiv2(true);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      if (selectedPrograms !== null) {
        setisdisabled(false);
      }
      else {
        setisdisabled(true);
      }
    }
    if (divId == 2) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(true);
      setVisibleDiv4(false);

      let hasInvalidNameOnClick = false;
      parents.map(parent => {
        parent?.children?.map(child => {
          if (seen.has(child.name.trim())) {
            duplicates.add(child.name.trim());
          } else {
            seen.add(child.name.trim());
          }
          if (hasDisallowedNameCharacters(child.name)) { hasInvalidNameOnClick = true; }
          if (child.name.trim() !== '') { countrecords = countrecords + 1; }
          countprojectvalue = countprojectvalue + 1;
        });
      });

      (!hasInvalidNameOnClick && (isVisibleDiv3 || (countrecords > 0 && countrecords === countprojectvalue && duplicates.size === 0))) ? setisdisabled(false) : setisdisabled(true);
    }
    if (divId == 3) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(true);
      if ((selectedManagedBy !== null && selectedManagedBy !== "") && (selectedSupportGrp.name !== "") && (selectedOpsvp !== null && selectedOpsvp !== "")
        && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedManagedBy)) && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedOpsvp))) {
        setisdisabled(false);
      }
      else {
        setisdisabled(true);
      }
    }
    if (divId == 4) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
    }
  }

  const formik: any = useFormik({
    initialValues: {
    },
    validate: (data) => {
      let errors = {
      };
    },
    onSubmit: (data) => {
      formik.resetForm();
    },
  });

  const isFormFieldValid = (number: any) =>
    !!(formik.touched[number] && formik.errors[number]);
  const getFormErrorMessage = (number: any) => {
    return (
      isFormFieldValid(number) && (
        <div className="p-error text-start ms-1 pt-1">
          {formik.errors[number]}
        </div>
      )
    );
  };

  const clientheader = () => {
    return (<h4 className="clsheader">Create a Project</h4>);
  }

  const clientdetailsheader = () => {
    return (<h4 className="clsheader">Project Configuration Details</h4>);
  }

  const handleChangeChildChannel = (parentId: string, childId: string, channel: Item[]) => {
    setParents(parents.map(parent =>
      parent.id === parentId
        ? {
          ...parent,
          children: parent?.children?.map(child =>
            child.id === childId
              ? { ...child, channel }
              : child
          )
        }
        : parent
    ));
  };

  const handleclientchange = (value: any) => {
    setSelectedItem(value);
    setisdisabled(false);
    if (value.name !== undefined) {
      getdropdowndataprogram("pr", value.code.toString());
      setData([
        {
          id: "client",
          name: value?.name,
          children: { ...parents }
        }
      ]);
    }
  }

  const handleprogramchange = (value: any) => {
    const defaultChannel = channelTypes?.find((c: any) => c.code === "1");
    setSelectedPrograms(value);
    setisdisabled(false);
    setParents([{
      id: "program",
      name: value.name + ' - ' + value.code,
      children: [{ id: "project_1", name: '', channel: defaultChannel ? [defaultChannel] : [] }]
    }]);
  }

  const programTemplate = (option: any) => {
    return (
      <div className="flex align-items-center">
        <div>{option.name} - {option.code}</div>
      </div>
    );
  };

  const selectedProgramTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.name} - {option.code}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const getsupportgroups = async () => {
    let supgrpResponse: any = await getDropdownValues("asknow_support_groups");
    let codes = supgrpResponse?.codes;
    setSupportGroups(codes);
  }

  const onopsvpblur = (e: any) => {
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(e.target.value)) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Valid Email Address",
          life: 3000,
        });
      }
      else {
        opsvpRef.current.focus();
        toast.current.show({
          severity: "warn",
          summary: "Warn",
          detail: "Please Enter Valid Email Address",
          life: 3000,
        });
      }
    }
  }

  const onmanagedbyblur = (e: any) => {
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(e.target.value)) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Valid Email Address",
          life: 3000,
        });
      }
      else {
        managedbyRef.current.focus();
        toast.current.show({
          severity: "warn",
          summary: "Warn",
          detail: "Please Enter Valid Email Address",
          life: 3000,
        });
      }
    }
  }

  const handlemanagedbychange = (val: any) => {
    setSelectedManagedBy(val);
    if ((val !== null && val !== "") && (selectedSupportGrp.name !== "") && (selectedOpsvp !== null && selectedOpsvp !== "")
      && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(val)) && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedOpsvp))) {
      setisdisabled(false);
    }
    else {
      setisdisabled(true);
    }
  }

  const handleopsvpchange = (val: any) => {
    setSelectedOpsvp(val);
    if ((selectedManagedBy !== null && selectedManagedBy !== "") && (selectedSupportGrp.name !== "") && (val !== null && val !== "")
      && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedManagedBy)) && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(val))) {
      setisdisabled(false);
    }
    else {
      setisdisabled(true);
    }
  }

  const handlesuppotgrpchange = (val: any) => {
    setSelectedSupportGrp(val);
    if ((selectedManagedBy !== null && selectedManagedBy !== "") && (val.name !== "") && (selectedOpsvp !== null && selectedOpsvp !== "")
      && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedManagedBy)) && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i.test(selectedOpsvp))) {
      setisdisabled(false);
    }
    else {
      setisdisabled(true);
    }
  }

  const saveCPPChildRequest = async (isSubmitted: boolean) => {
    const valid = await validateAllProjects();
    if (!valid) {
      return;
    }

    setShowLoader(true);
    setissave(!isSubmitted);
    setissubmit(isSubmitted);

    const normalizedData = data.map(client => ({
      ...client,
      children: client.children?.map(program => ({
        ...program,
        children: program.children?.map((child: any) => ({
          ...child,
          channelid: (child.channel || []).map((c: any) => c.code).join("|"),
          channelname: (child.channel || []).map((c: any) => c.name).join("|"),
          channel: undefined
        }))
      }))
    }));

    var request = {
      Data: normalizedData,
      ManagedBy: selectedManagedBy,
      OpsVP: selectedOpsvp,
      SupportGroup: selectedSupportGrp?.name,
      IsSubmit: isSubmitted
    };

    let BASE_URL = process.env.REACT_APP_API_URI;
    let url = BASE_URL + SAVECPPCHILDREQUEST_URL;

    const res: any = await new Promise((resolve, reject) => {
      try {
        axios
          .postRequest(url, request)
          .then((res: any) => {
            setShowLoader(false);
            resolve(res);
          })
          .catch((err: any) => {
            setShowLoader(false);
            setissubmitsuccess(false);
            setissavesuccess(false);
            resolve(err);
          });
      } catch (error) {
        setShowLoader(false);
        setissubmitsuccess(false);
        setissavesuccess(false);
        reject(error);
      }
    });

    if (res.status == "Success") {
      setissubmitsuccess(true);
      setissavesuccess(true);
    } else {
      setissubmitsuccess(false);
      setissavesuccess(false);
    }
    setShowLoader(false);
  }

  const validateProject = async (name: any, type: any, id: any) => {
    let url = BASE_URL + ValidateProgramProject_URL;
    const res: any = await new Promise((resolve, reject) => {
      try {
        setShowLoader(true);
        axios
          .getRequest(url + "?name=" + name + "&type=" + type + "&code=" + id + '&id=' + 0)
          .then((res: any) => {
            setShowLoader(false);
            hideLoader();
            resolve(res);
          })
          .catch((err: any) => {
            setShowLoader(false);
            hideLoader();
            resolve(err);
          });
      } catch (error) {
        setShowLoader(false);
        hideLoader();
        reject(error);
      }
    });

    if (res.statusCode === 200 && res.isValid) {
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Valid Project Name",
        life: 3000,
      });
    } else if (res.statusCode === 200 && !res.isValid) {
      projectRef.current.focus();
      toast.current.show({
        severity: "warn",
        summary: "Warn",
        detail: "Project Name already exists for this Program",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error checking for valid Project Number",
        life: 3000,
      });
    }
  };

  const onprojectblur = (e: any) => {
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      if (hasDisallowedNameCharacters(e.target.value)) {
        projectRef.current.focus();
        toast.current.show({ severity: "warn", summary: "Warn", detail: buildDisallowedNameCharsMessage(e.target.value), life: 3000 });
        return;
      }
      validateProject(
        e.target.value,
        'project',
        selectedPrograms?.code
      );
    }
  }

  const validateAllProjects = async (): Promise<boolean> => {
    let allValid = true;

    for (const parent of parents) {
      for (const child of parent.children || []) {
        if (child.name.trim()) {
          try {
            const res: any = await axios.getRequest(
              `${BASE_URL}${ValidateProgramProject_URL}?name=${child.name}&type=project&code=${selectedPrograms?.code}&id=0`
            );

            if (!(res.statusCode === 200 && res.isValid)) {
              hideLoader();
              toast.current.show({
                severity: "warn",
                summary: "Invalid Project Name",
                detail: `Project "${child.name}" already exists for this Program`,
                life: 3000,
              });
              allValid = false;
            }
          } catch (err) {
            hideLoader();
            toast.current.show({
              severity: "error",
              summary: "Network Error",
              detail: `Could not validate project: ${child.name}`,
              life: 3000,
            });
            allValid = false;
          }
        }
      }
    }

    return allValid;
  };

  const renderChannelDropdown = (parentId: string, childId: string, selectedChannels: Item[]) => {
    const dropdownKey = `${parentId}_${childId}`;
    const isOpen = channelDropdownOpen[dropdownKey] || false;
    const allSelected = channelTypes.length > 0 && selectedChannels.length === channelTypes.length;

    return (
      <div
        ref={el => { channelDropdownRefs.current[dropdownKey] = el; }}
        style={{ position: "relative", width: "100%" }}
      >
        <div
          onClick={() => props.mode !== "View" && toggleChannelDropdown(dropdownKey)}
          style={{
            border: "1px solid #ced4da",
            borderRadius: "4px",
            padding: "8px 12px",
            cursor: props.mode === "View" ? "default" : "pointer",
            background: props.mode === "View" ? "#f8f9fa" : "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: "42px"
          }}
        >
          <span style={{ fontSize: "14px", color: selectedChannels.length === 0 ? "#aaa" : "#000" }}>
            {selectedChannels.length === 0
              ? "Select Channel(s)"
              : selectedChannels.length <= 2
                ? selectedChannels.map(c => c.name).join(", ")
                : `${selectedChannels.length} channels selected`}
          </span>
          <i className="pi pi-chevron-down" style={{ fontSize: "12px", color: "#666" }} />
        </div>
        {isOpen && (
          <div style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ced4da",
            borderRadius: "4px",
            zIndex: 9999,
            maxHeight: "200px",
            overflowY: "auto",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
          }}>
            {channelTypes.map((channel: any) => {
              const selected = selectedChannels.some(c => c.code === channel.code);
              return (
                <div
                  key={channel.code}
                  onClick={() => {
                    const updated = selected
                      ? selectedChannels.filter(c => c.code !== channel.code)
                      : [...selectedChannels, channel];
                    handleChangeChildChannel(parentId, childId, updated);
                  }}
                  style={{
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: selected ? "#e8f4ff" : "#fff",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    borderBottom: "1px solid #f0f0f0"
                  }}
                >
                  <input type="checkbox" readOnly checked={selected} style={{ cursor: "pointer", accentColor: "#3299FF" }} />
                  {channel.name}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="row m-2 mt-4"><NavLink to={NEWCPPREQUEST}><h4>{'< Back to Creation Menu'}</h4></NavLink></div>
      <form onSubmit={formik.handleSubmit} className="p-fluid" autoComplete="off">
        <div className="divCard">
          <Card className="clscard col-md-8 mt-4" header={clientheader}>
            <div className="row m-3 mt-4">
              <div className="divsteps col-md-12 m-1">
                <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} />
              </div>
              <div className="col-md-4 clientimg"><img src={img} style={{ width: '300px' }} />
              </div>
              <div className="col-md-8">
                <Toast ref={toast} />
                <div className="client-naming-form">
                  <div className="d-flex flex-column flex-shrink-0 p-3 w-100">
                    {isVisibleDiv1 ? (
                      <div className="divscroll">
                        <div className="label-bold">Client Code or Name</div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl"
                              htmlFor="client"
                              className={classNames({
                                "p-error": isFormFieldValid("client"),
                              })}
                            >
                              Client*
                            </label>
                            <Dropdown
                              id="client"
                              name="client"
                              filter
                              placeholder="Select a Client"
                              value={selectedItem}
                              virtualScrollerOptions={{ itemSize: 30 }}
                              onChange={(e: DropdownChangeEvent) => handleclientchange(e.value)}
                              options={client}
                              className={classNames({
                                "p-invalid": isFormFieldValid("client"),
                              })}
                              optionLabel="name"
                            />
                            {getFormErrorMessage("client")}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {isVisibleDiv2 ? (
                      <div className="divscroll">
                        <div className="label-bold">Program Code or Name</div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl"
                              htmlFor="program"
                              className={classNames({
                                "p-error": isFormFieldValid("program"),
                              })}
                            >
                              Program*
                            </label>
                            <Dropdown
                              id="program"
                              name="program"
                              filter
                              placeholder="Select a Program"
                              value={selectedPrograms}
                              onChange={(e: DropdownChangeEvent) => handleprogramchange(e.value)}
                              options={programs}
                              itemTemplate={programTemplate}
                              valueTemplate={selectedProgramTemplate}
                              className={classNames({
                                "p-invalid": isFormFieldValid("program"),
                              })}
                              optionLabel="name"
                            />
                            {getFormErrorMessage("program")}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {isVisibleDiv3 ? (
                      <div className="divscroll">
                        <div className="label-bold">Project Names
                          <Tooltip target=".custom-target-icon" />
                          <i className="custom-target-icon"
                            data-pr-position="right"
                            data-pr-at="right+5 top"
                            data-pr-my="left center-2"
                            data-pr-tooltip="Please enter values in all textboxes and make sure no duplicate values are present to proceed further"
                            style={{
                              fontSize: '1.5rem',
                              cursor: 'pointer',
                              height: '5rem'
                            }}>
                            <img src={helpicon} alt="Help" />
                          </i>
                        </div>
                        <div className="clscol m-2">
                          {parents.map(parent => (
                            <div key={parent.id}>
                              <div className="clscol ms-5">
                                {parent?.children?.map(child => (
                                  <div key={child.id} style={{ marginBottom: '10px' }}>
                                    <span>
                                      <label id="lbl"
                                        htmlFor="projectname"
                                      >
                                        Project Name {child.id.split("_")[1]}
                                      </label>
                                      <div style={{ display: 'flex' }}>
                                        <InputText
                                          id={"projectname_" + child.id.toString()}
                                          name="projectname"
                                          type="text"
                                          placeholder="Enter Project Name"
                                          value={child.name}
                                          onChange={(e) => handleChangeChild(parent.id, child.id, e.target.value)}
                                          onBlur={(e: any) => onprojectblur(e)}
                                          ref={projectRef}
                                        />
                                        <span className="p-inputgroup-addon">
                                          <button type="button" className="clsbtn" onClick={() => handleRemoveChild(parent.id, child.id)}><img src={deleteicon} /></button>
                                        </span>
                                      </div>
                                      <div className="mt-2">
                                        <span className="selectList">
                                          <label id="lbl" htmlFor="channeltype">
                                            Channel
                                          </label>
                                          {renderChannelDropdown(parent.id, child.id, child.channel || [])}
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                ))}
                                <div className="clscol mt-3">
                                  <button type="button" className="clsbtn" onClick={() => handleAddChild(parent.id)}><img src={addicon} /> Add Project</button>
                                </div>
                              </div>
                              <hr></hr>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {isVisibleDiv4 ? (
                      <div className="divscroll">
                        <div className="label-bold">AskNow Business Service</div>

                        <div className="clscol m-2">
                          <span>
                            <label id="lbl"
                              htmlFor="managedBy"
                              className={classNames({
                                "p-error": isFormFieldValid("managedBy"),
                              })}
                            >
                              Managed By*
                            </label>
                            <InputText
                              id="managedBy"
                              name="managedBy"
                              type="text"
                              placeholder="Enter Email Address"
                              onChange={(e: any) => handlemanagedbychange(e.target.value)}
                              value={selectedManagedBy}
                              onBlur={(e: any) => onmanagedbyblur(e)}
                              className={classNames({
                                "p-invalid": isFormFieldValid("managedBy"),
                              })}
                              ref={managedbyRef}
                            />
                            {getFormErrorMessage("managedBy")}
                            <span className="instruction">
                              *This is the IT PM or TAM or whoever will be the RFC approver
                            </span>
                          </span>
                        </div>
                        <div className="clscol m-2">
                          <span className="selectList">
                            <label id="lbl"
                              htmlFor="supportGroups"
                              className={classNames({
                                "p-error": isFormFieldValid("supportGroups"),
                              })}
                            >
                              Support Group*
                            </label>
                            <Dropdown
                              id="supportGroups"
                              name="supportGroups"
                              filter
                              onChange={(e: any) => handlesuppotgrpchange(e.target.value)}
                              value={selectedSupportGrp}
                              options={supportgroups}
                              className={classNames({
                                "p-invalid": isFormFieldValid("supportGroups"),
                              })}
                              optionLabel="name"
                            />
                            {getFormErrorMessage("supportGroups")}
                          </span>
                        </div>

                        <div className="clscol m-2">
                          <span>
                            <label id="lbl"
                              htmlFor="opsVP"
                              className={classNames({
                                "p-error": isFormFieldValid("opsVP"),
                              })}
                            >
                              Ops VP*
                            </label>
                            <InputText
                              id="opsVP"
                              name="opsVP"
                              type="email"
                              onChange={(e: any) => handleopsvpchange(e.target.value)}
                              value={selectedOpsvp}
                              disabled={props.mode === "View" ? true : false}
                              placeholder="Enter Email Address"
                              onBlur={(e: any) => onopsvpblur(e)}
                              className={classNames({
                                "p-invalid": isFormFieldValid("opsVP"),
                              })}
                              ref={opsvpRef}
                            />
                            {getFormErrorMessage("opsVP")}
                          </span>
                        </div>
                        <div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {(!isVisibleDiv1 && !isVisibleDiv2 && !isVisibleDiv3 && !isVisibleDiv4) &&
                      <div className="clsreview">
                        {(!issubmit && !issave) &&
                          <><h2 className="clstext"><b>Project Review</b></h2>
                            <h6 className="clstext">Please review all Project details before saving or submiting</h6>
                          </>
                        }
                        {(!showLoader && ((issave && issavesuccess) || (issubmit && issubmitsuccess))) &&
                          <><h2 className="clstext"><b>Congratulations!</b></h2>
                            <h6 className="clstext">{issave ? "You've successfully saved a new project" : "You've successfully submitted a new project"} </h6>
                          </>
                        }
                        {(!showLoader && ((issave && !issavesuccess) || (issubmit && !issubmitsuccess))) &&
                          <><h2 className="clstext"><b>Something went wrong.</b></h2>
                            <h6 className="clstext">{issave ? "Error while saving a new project.Please try again" : "Error while submitting a new project.Please try again"} </h6>
                          </>
                        }
                        {(showLoader) &&
                          <><h2 className="clstext"><b>Pleast wait!</b></h2>
                            <h6 className="clstext">Processing your request</h6>
                          </>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <Card className="clscard col-md-4 mt-4" header={clientdetailsheader}>
            <div className="clscontent">
              {selectedItem &&
                <Tree value={data.map(convertToTreeNode)}
                  nodeTemplate={nodeTemplate}
                  expandedKeys={expandedKeys}
                  onToggle={(e) => setExpandedKeys(e.value)}
                  selectionMode="single"
                  className="w-full md:w-30rem m-1"
                />
              }
              {selectedManagedBy !== null && selectedSupportGrp.name !== "" && selectedOpsvp !== null &&
                <Card className="m-2">
                  <table className="tbleven clstable">
                    <thead><tr className="clstr"><th className="clsth" colSpan={2}><b>AskNow Business Service</b></th></tr></thead>
                    <tbody>
                      <tr className="clstr">
                        <td className="clstd">Managed By*</td>
                        <td className="clstd">{selectedManagedBy}</td>
                      </tr>
                      <tr className="clstr">
                        <td className="clstd">Support Group*</td>
                        <td className="clstd">{selectedSupportGrp?.name}</td>
                      </tr>
                      <tr className="clstr">
                        <td className="clstd">Ops VP*</td>
                        <td className="clstd">{selectedOpsvp}</td>
                      </tr>
                    </tbody>
                  </table>
                </Card>}
            </div>
          </Card>
        </div>
        {(!issubmitsuccess && !issavesuccess) &&
          <div className="btnnav col-md-8">
            <div className="childfooterleft">
              {activeIndex !== 0 &&
                <Button
                  onClick={() => onHideShowClick((activeIndex == 0) ? activeIndex : activeIndex - 1)}
                  type="button"
                  label="Back"
                  className="btnBack"
                  outlined
                  size="large"
                />}
            </div>
            <div className="childfooterright">
              {((activeIndex !== 4)) &&
                <Button
                  onClick={() => onHideShowClick(((activeIndex <= 3) ? activeIndex + 1 : activeIndex))}
                  type="button"
                  label="Next"
                  className="btnNext"
                  disabled={isdisabled}
                  size="large"
                />}
              {(activeIndex === 4) &&
                <>
                  <div>
                    <Button
                      onClick={() => saveCPPChildRequest(false)}
                      type="button"
                      label="Save as Draft"
                      className="btnNext"
                      size="large"
                    />
                    <Button
                      onClick={() => saveCPPChildRequest(true)}
                      type="submit"
                      label="Submit"
                      className="btnNext"
                      size="large"
                    />
                  </div>
                </>}
            </div>
          </div>}
        {
          ((issubmitsuccess || issavesuccess) && props.requestDetails == null) &&
          <div className="btnnav col-md-8">
            <div className="childfooterleft">
            </div>
            <div className="childfooterright">
              <Button
                onClick={() => navigate(NEWPROJECTREQUEST)}
                type="button"
                label="Create Another Project"
                className="btnNext"
                size="large"
              />
            </div>
          </div>
        }
        {/* {(issubmitsuccess || issavesuccess) &&
          <div className="btnnav col-md-8">
            <div className="childfooterleft">
            </div>
            <div className="childfooterright">
              <Button
                // onClick={() => HideDialog(true)}
                type="button"
                label="Close"
                className="btnNext"
                size="large"
              />
            </div>
          </div>
        } */}
        <div>
          {showLoader && (
            <div className="divSpinner2">
              <Spinner />
            </div>
          )}
        </div>
      </form>
    </>
  )
}
